import React, { useState } from "react";
// import logo from './logo.svg';
import "./App.scss";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PartnerLogin from "./Login/PartnerLogin";

import ConfirmingSpinner from "../components/ConfirmingSpinner/ConfirmingSpinner";
import confidentSfx from "../sfx/confident.mp3";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import * as actions from ".././actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Layout from "../components/Layout/Layout";
import ForgotPassword from "./ForgotPassword/ForgotPassword";
import ConfirmEmail from "./ConfirmEmail/ConfirmEmail";
import PasswordEdit from "./PasswordEdit/PasswordEdit";
import PartnerSignup from "./Signup/PartnerSignup";
import { ActionCableConsumer } from "react-actioncable-provider";
import AdminLoginPage from "./Login/AdminLogin";

const App = (props) => {
  const [state, setState] = useState({
    confirmingLoggedIn: false,
  });

  const notification_received = (msg) => {
    var audio = new Audio(confidentSfx);
    audio.play();
    // console.log("SOMETHING RECEIVED", msg);
    toast.success(
      <p>
        {msg.msg} <br />
        <a href={msg.link} className="btn btn-xs btn-primary form-control">
          View
        </a>
      </p>,
      { autoClose: false }
    );
  };
  const getLayoutOrRedirect = () => {
    // console.log(props.authentication);
    return (
      <>
        {props.authentication.default_path === "/admins/" && (
          <ActionCableConsumer
            channel={{
              channel: "AdminNotificationsChannel",
              id: props.authentication.user.uuid,
            }}
            onReceived={notification_received}
            onConnected={() => {
              console.log("WEBCONNECTED TO WEBSOCKET");
            }}
            onRejected={() => {
              console.log("WEBCONNECTION DISCONNECTED");
            }}
          />
        )}
        <Layout />{" "}
      </>
    );
  };
  const isLoggedIn = () => {
    if (props.authentication.loggedIn || props.authentication.loggedIn) {
      return true;
    }
    return false;
  };
  const isAdmin = () => {
    if (window.location.pathname === "/admins") {
      return true;
    } else {
      return false;
    }
  };
  return (
    <Router>
      <div className="App container-fluid h-100">
        <div className="row h-100">
          <div className="col-md-12">
            <ToastContainer autoClose={2000} />
            <Switch>
              <Route exact path="/partners/sign_up">
                <PartnerSignup />
              </Route>

              <Route
                exact
                path="/partners/forgot_password"
                location={props.location}
              >
                <ForgotPassword />
              </Route>
              <Route
                exact
                path="/partners/confirm_email"
                location={props.location}
              >
                <ConfirmEmail />
              </Route>
              <Route
                exact
                path="/partners/password_edit"
                location={props.location}
              >
                <PasswordEdit route="partners"/>
              </Route>
                <Route
                exact
                path="/admins/password_edit"
                location={props.location}
              >
                <PasswordEdit route="management"/>
              </Route>
              <Route
                exact
                path="/management/password"
                location={props.location}
              >
                <ForgotPassword />
              </Route>

              {!isLoggedIn() ? (
                isAdmin() ? (
                  <AdminLoginPage location={props.location} />
                ) : (
                  <PartnerLogin location={props.location} />
                )
              ) : state.confirmingLoggedIn ? (
                <ConfirmingSpinner />
              ) : (
                getLayoutOrRedirect()
              )}
              <Route exact path="/admins/">
                <AdminLoginPage location={props.location} />
              </Route>
            </Switch>
          </div>
        </div>
      </div>
    </Router>
  );
};

const mapStateToProps = (state) => ({
  authentication: state.authentication,
  // notifications: state.notifications,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
  // addNotification: bindActionCreators(addNotification, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
